import { render, staticRenderFns } from "./k-flow-form.vue?vue&type=template&id=142b1faa"
import script from "./k-flow-form.vue?vue&type=script&lang=js"
export * from "./k-flow-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports